var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("../assets/icon/error.svg"),"alt":""}}),_c('p',[_vm._v("错误: "+_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }